module.exports = __webpack_public_path__ + "static/media/fra.413b79e1.svg";